import React, { useContext, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { changes } from "src/components/utils/fields";
import { useMediaQuery } from "@mui/material";
import {
  BufferService,
  LoadingContext,
  NavigateContext,
  M_Button,
  M_Fieldset,
  M_Header,
  M_MessageBoard,
} from "src/M_Components";
import { Check, Info, Refresh } from "@mui/icons-material";
import { QuoteInfo } from "./components/QuoteInfo";
import { QuoteDates } from "./components/QuoteDates";
import { QuotePorts } from "./components/QuotePorts";
import { QuoteEntities } from "./components/QuoteEntities";
import { QuoteEquipment } from "./components/QuoteEquiment";
import { QuoteGoods } from "./components/QuoteGoods";
import { QuoteCalculator } from "./components/QuoteCalculator";
import { QuoteCharges } from "./components/QuoteCharges";

export const QuoteDetail = ({ roles }) => {
  const [id, setId] = useState(sessionStorage.getItem("selectedTab"));
  const { t } = useTranslation();
  const ctx = useContext(LoadingContext);
  const navigateCtx = useContext(NavigateContext)
  const [data, setData] = useState({});
  const [open, setOpen] = useState(false);
  const [passedRow, setPassedRow] = useState({});
  const [operation, setOperation] = useState("");
  const [isFirstTime, setIsFirstTime] = useState(true);
  const [triggerAddNewCharge, setTriggerAddNewCharge] = useState(false);
  const [showPageCloseModal, setShowPageCloseModal] = useState(false);

  const accountService = new BufferService("Account");
  // const quoteService = new BufferService("Quote");
  const quoteGetRequestService = new BufferService("quotegetrequest");
  const quoteCreateRequestService = new BufferService("quotecreaterequest");
  const quoteUpdateRequestService = new BufferService("quoteupdaterequest");

  const sessionKeys = ["operation", "data", "open", "passedRow"];

  const matches11 = useMediaQuery("(min-width:970px)");
  const matches12 = useMediaQuery("(min-width:930px)");
  const matches16 = useMediaQuery("(min-width:440px)");

  useEffect(() => {
    if (isFirstTime) {
      ctx.setIsLoad(true);
      getSessionStorageData(id);
      setIsFirstTime(false);
      sessionStorage.setItem(`tab${id}`, JSON.stringify(sessionKeys));
    }
  }, []);

  useEffect(() => {
    const passOperation = ctx.passValue.get("operation");
    setOperation(passOperation);
  }, []);

  useEffect(() => {
    const newId = sessionStorage.getItem("selectedTab");
    if (newId !== id) {
      setId(newId);
      getSessionStorageData(newId);
    }
  }, []);

  useEffect(() => {
    sessionKeys.forEach((key) => {
      sessionStorageMachine(id, key, key);
    });
    // eslint-disable-next-line
  }, [id, operation, data]);

  const sessionStorageMachine = (id, key, value) => {
    if (eval(value) instanceof Object && Object.keys(eval(value)).length === 0)
      return;
    if (eval(value) instanceof String && eval(value) === "") return;
    if (eval(value) instanceof Number && eval(value) === "") return;

    // eslint-disable-next-line
    if (eval(value) instanceof Map) {
      // eslint-disable-next-line
      sessionStorage.setItem(
        `${id}${key}`,
        JSON.stringify(Array.from(eval(value))),
      );
    } else {
      // eslint-disable-next-line
      sessionStorage.setItem(`${id}${key}`, JSON.stringify(eval(value)));
    }
  };

  const getSessionStorageData = (sessionID) => {
    ctx.setIsLoad(true);
    const tempO = JSON.parse(sessionStorage.getItem(`${sessionID}operation`));
    const tempD = JSON.parse(sessionStorage.getItem(`${sessionID}data`));
    const tempOS = JSON.parse(sessionStorage.getItem(`${sessionID}open`));
    const tempPR = JSON.parse(sessionStorage.getItem(`${sessionID}passedRow`));

    if (
      (tempO && tempO !== "") ||
      (tempD && Object.keys(tempD).length !== 0) ||
      tempOS ||
      (tempPR && Object.keys(tempD).length !== 0)
    ) {
      setOperation(new String(tempO));
      setData(new Object(tempD));
      setOpen(tempOS);
      setPassedRow(tempPR);
      ctx.setIsLoad(false);

      return;
    }
    get();
  };

  const functionLeavingPage = () => {
    navigateCtx.closeTab(JSON.parse(id))
  }

  const fixResponseObject = (obj) =>
    Object.fromEntries(
      Object.entries(obj).map(([key, value]) => [
        key.charAt(0).toLowerCase() + key.slice(1),
        value,
      ]),
    );

  const fixResponseListObject = (obj) =>
    obj.map((element) =>
      Object.fromEntries(
        Object.entries(element).map(([key, value]) => [
          key.charAt(0).toLowerCase() + key.slice(1),
          value,
        ]),
      ),
    );

  const get = () => {
    const row = ctx.passValue.get("Row")
    const rows = ctx.passValue.get("Rows")

    const pvOperation = ctx.passValue.get("operation")

    if ((pvOperation === "edit" || pvOperation === 'copyHeader' || pvOperation === 'copyHeaderAndCharges') && row && (!rows || rows.length === 1)) {
      const lines = ctx.passValue.get('Row')
      const tempId = lines.Id
      console.log("1", tempId)
      quoteGetRequestService.getId(tempId).then((response) => {
        if (response.name === "AxiosError") {
          ctx.toastMessages(
            "error",
            t("Error"),
            response?.response?.data?.Errors || response.message,
          );
          ctx.setIsLoad(false);
          return;
        }

        const fixedQuoteResponse = fixResponseObject(response.Quote);
        const fixedGoodsResponse = pvOperation === 'copyHeader' || pvOperation === 'copyHeaderAndCharges' ? 
          [] : fixResponseListObject(response.Goods);
        const fixedEquipmentResponse = pvOperation === 'copyHeader' || pvOperation === 'copyHeaderAndCharges' ? 
          [] : fixResponseListObject(response.Equipment);
        const fixedChargesResponse = pvOperation === 'edit' || pvOperation === 'copyHeaderAndCharges' ? (response.Charges ? fixResponseListObject(response.Charges) : []) : [];
        const fixedChargesResponseWithId = fixedChargesResponse.map((value, index) => ({ ...value, id: index }))

        delete fixedQuoteResponse.Goods;
        delete fixedQuoteResponse.Equipment;
        delete fixedQuoteResponse.Charges;

        const fixedQuoteResponseDates = {
          ...fixedQuoteResponse,
          startDate: fixedQuoteResponse.startDate?.split("T")[0],
          dueDate: fixedQuoteResponse.dueDate?.split("T")[0],
          expireDate: fixedQuoteResponse.expireDate?.split("T")[0],
        };

        const fixedEquipmentTypesResponse = fixedEquipmentResponse.map(
          (equipment) => ({
            ...equipment,
            equipmentType: `${equipment["equipmentTypeLenght"]}${equipment["equipmentTypeCode"]}`,
          }),
        );

        const fixedAllResponses = {
          ...fixedQuoteResponseDates,
          Goods: fixedGoodsResponse,
          Equipments: fixedEquipmentTypesResponse,
          charges: fixedChargesResponseWithId,
        };

        setData(fixedAllResponses);
        changes(
          "counterCharges",
          fixedAllResponses.charges.length,
          setData,
        );

        changes(
          "GoodsCounter",
          fixedAllResponses.Goods.length,
          setData,
        );

        ctx.setIsLoad(false);
      })
        .catch((err) => {
          ctx.toastMessages("error", err.message, "Error");
          ctx.setIsLoad(false);
        });
    } else {
      changes("counterCharges", 0, setData);
      if (ctx.passValue.get("Rows")?.length > 1) {
        setData({ ...data, isMultiEdit: true });
      }
    }

    changes("totalCurrency", "€", setData);

    getCompanies();
    ctx.setIsLoad(false);
  };

  useEffect(() => {
    if (!triggerAddNewCharge) setTriggerAddNewCharge(true);
  }, [data])

  const getCompanies = () => {
    let tempCompanies = JSON.parse(sessionStorage.getItem("companies"));
    if (tempCompanies.length === 0) {
      ctx.toastMessages("error", "User has no companies!", "");
    }
    if (tempCompanies.length === 1) {
      getAccount(tempCompanies[0]);
    }

    changes(
      "companyOptions",
      tempCompanies.map((field) => {
        return { label: field.Name, value: field.AccountId, ...field };
      }),
      setData,
    );
  };

  const getAccount = (accountId) => {
    if (accountId) {
      accountService.getId(accountId).then((res) => {
        if (res.name === "AxiosError") {
          ctx.toastMessages("error", "Couldnt fetch Account!", "");
          return;
        }
        changes("clientCode", res.AccountCode, setData);
        changes("clientVat", res.AccountVATNumber, setData);
      });
    } else {
      changes("clientCode", "", setData);
      changes("clientVat", "", setData);
    }
  };

  const onSave = (status) => {
    if (!data.charges || data.charges.length === 0) {
      ctx.toastMessages("error", '', t("ChargesRequiredError"));
      return;
    }

    const chargeRequiredFields = [
      { key: 'serviceCode', label: t('ServiceCode') },
      { key: 'currencyCode', label: t('Currency') },
      { key: 'salesValue', label: t('SalesValue') },
      { key: 'quantity', label: t('Quantity') },
      { key: 'multiple', label: t('Multiple') },
      { key: 'goalValue', label: t('Goal') },
    ];

    for (let i = 0; i < data.charges.length; i++) {
      const charge = data.charges[i];
      const missing = chargeRequiredFields
        .filter(f => !charge[f.key] && charge[f.key] !== 0)
        .map(f => f.label);
      if (missing.length > 0) {
        ctx.toastMessages("error", '', <span><b>{t('ChargesMissingFields')}</b>: {missing.join(', ')}</span>);
        return;
      }
    }

    const tempCharges = data.charges?.map((obj) => {
      const { id, ...rest } = obj;
      return {
        ...rest,
        serviceId: rest.serviceId || null,
        currencyId: rest.currencyId || null,
        costCurrencyId: rest.costCurrencyId || null,
        supplierId: rest.supplierId || null,
        costValue: rest.costValue !== '' && rest.costValue != null ? Number(rest.costValue) : 0,
        salesValue: rest.salesValue !== '' && rest.salesValue != null ? Number(rest.salesValue) : 0,
        quantity: rest.quantity !== '' && rest.quantity != null ? Number(rest.quantity) : 0,
      };
    });

    if (!data.Equipments) data.Equipments = [];

    const tempEquipments = data.Equipments?.map((obj) => {
      const { Id, equipmentType, ...rest } = obj;
      return rest;
    });

    const tempGoods = data.Goods?.map((obj) => {
      const { Id, ...rest } = obj;
      return {
        ...rest,
        dangerousGoodsId: rest.dangerousGoodsId || null,
        commodityId: rest.commodityId || null,
        grossWeight: rest.grossWeight !== '' && rest.grossWeight != null ? Number(rest.grossWeight) : 0,
      };
    });

    const rows = ctx.passValue.get("Rows")

    const saveData = {
      Equipments: tempEquipments,
      Goods: tempGoods,
      Charges: tempCharges,
      Quote: status ? { ...data, Status: status } : data,
      IsMultiEdit: data.isMultiEdit,
      MultiEditQuoteIds: rows?.map((x) => x.Id),
    };
      ctx.setIsLoad(true);

      console.log("operation", operation)

    if (operation === "create" || operation === "Request" || operation === 'copyHeader'  || operation === 'copyHeaderAndCharges') {
      quoteCreateRequestService.post(saveData).then((response) => {
        if (response.name === "AxiosError") {
          const data = response?.response?.data

          ctx.toastMessages(
            "error",
            t("ErrorCreating"),
            data !== null && data !== undefined ? Object.values(data).flat().join("\n") || response.message : "",
          );
          ctx.setIsLoad(false);
        } else {
          ctx.toastMessages(
            "success",
            t("Success"),
            t("CreatedQuote"),
          );
          ctx.setIsLoad(false);

          navigateCtx.closeTab(id.replace(/"/g, ''))
        }
      });
    } else if (operation === "edit" || operation === "EditRequest") {
      quoteUpdateRequestService.update(data.id, saveData).then((response) => {
        if (response.name === "AxiosError") {
          const data = response?.response?.data

          ctx.toastMessages(
            "error",
            t("ErrorUpdating"),
            data !== null && data !== undefined ? Object.values(data).flat().join("\n") || response.message : "",
          );
          ctx.setIsLoad(false);
        } else {
          ctx.toastMessages(
            "success",
            t("Success"),
            t("EditedQuote"),
          );
          ctx.setIsLoad(false);

          navigateCtx.closeTab(id.replace(/"/g, ''))
        }
      });
    }
  };

  return (
    <div>
      <M_Header
        element={
          <>
            <M_Button
              tooltip={t("Back")}
              label={t("Back")}
              icon={<i className="pi pi-arrow-left iconTable" style={{ width: '20px', color: ctx.secondaryColor ? ctx.secondaryColor : 'var(--color-black)' }}></i>}
              onClick={() => { setShowPageCloseModal(true) }}
            />
            <M_Button
              tooltip={t("LabelSubmitForApproval")}
              icon={<Check />}
              label={t("LabelSubmitForApproval")}
              onClick={() => onSave("W")}
            />
          </>
        }
      />
      <div style={{ margin: "20px" }}>
        {data.isMultiEdit && (
          <M_Fieldset
            labelInside
            label={
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  fontSize: "25px",
                  marginLeft: "10px",
                }}
              >
                <Info style={{ marginRight: "10px", scale: "1.3" }} />{" "}
                {t("MultiEditInfoTitle")}
              </div>
            }
            elements={<div>{t("MultiEditInfoContent")}</div>}
          />
        )}
        {data.bookingId !== null && data.bookingId !== undefined && (
          <M_Fieldset
            labelInside
            label={
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  fontSize: "25px",
                  marginLeft: "10px",
                }}
              >
                <Info style={{ marginRight: "10px", scale: "1.3" }} />{" "}
                {t("QuoteHasBookingCreatingNewTitle")}
              </div>
            }
            elements={<div>{t("QuoteHasBookingCreatingNewBody")}</div>}
          />
        )}
        <div
          style={{
            display: "grid",
            gridTemplateColumns: (!matches11 && "auto ") || "auto auto auto",
          }}
        >
          <QuoteInfo dataState={data} setDataState={setData} />
          <QuoteDates dataState={data} setDataState={setData} />
          <QuotePorts dataState={data} setDataState={setData} />
        </div>
        <div>
          <QuoteEntities dataState={data} setDataState={setData} />
        </div>
        <div
          style={{
            display: (!matches16 && "flex") || "grid",
            flexDirection: "column",
            gridTemplateColumns: (!matches12 && "auto") || "auto auto",
          }}
        >
          <QuoteEquipment dataState={data} setDataState={setData} />
          <QuoteGoods dataState={data} setDataState={setData} />
        </div>
        <QuoteCharges
          dataState={data}
          setDataState={setData}
          passedRowState={passedRow}
          setPassedRowState={setPassedRow}
          triggerAddNewCharge={triggerAddNewCharge}
        />
        <div style={{ margin: "25px" }}></div>
        <QuoteCalculator dataState={data} setDataState={setData} />
      </div>
      <M_MessageBoard
        warning
        open={showPageCloseModal}
        onClose={() => setShowPageCloseModal(false)}
        title={t("leavingPageTitle")}
        body={t("leavingPageBody")}
        footer={
            <span style={{ display: 'flex', alignItems: 'center' }}>
                <M_Button hoverEffect normal labelColor={'white'} backgroundColor={'var(--color-red)'} onClick={() => setShowPageCloseModal(false)} label={t("ButtonCancel")} />
                <M_Button hoverEffect normal labelColor={'white'} backgroundColor={'var(--color-green)'} onClick={functionLeavingPage} label={t("ButtonConfirm")} />
            </span>
        }
      />
    </div>
  );
};
